

















import Vue from "vue";
import Component from "vue-class-component";
import { AppMutationTypes } from "@/store/mutations";
import store from "@/store";
@Component({})
export default class UpdateAvailableNotification extends Vue {
    mounted() {
        window.addEventListener("api-update", this.handleAppUpdate);
        this.$bvToast.hide("update-available-toast");
    }

    handleAppUpdate(e: Event): void {
        this.$bvToast.show("update-available-toast");
        store.commit(AppMutationTypes.setUpdateAvailable, true);
    }

    updateSite(): void {
        location.reload();
    }
}
